import { Modal } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import Button from 'app/atoms/Button';

interface ConfirmationModalProps {
  isVisible: boolean;
  title: string;
  description: string;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  confirmText?: string;
  cancelText?: string;
  danger?: boolean;
}

const ConfirmationModal = ({
  isVisible,
  title,
  description,
  onCancel,
  onConfirm,
  isLoading,
  confirmText = 'Yes',
  cancelText = 'No',
  danger = false,
}: ConfirmationModalProps) => {
  return (
    <Modal
      className="max-w-[420px]"
      open={isVisible}
      centered
      title={false}
      closeIcon={false}
      onCancel={onCancel}
      footer={
        <div className="flex gap-3 w-full">
          <Button className="w-full" variant="secondary" onClick={onCancel} data-testid="modal-cancel">
            {cancelText}
          </Button>
          <Button
            className="w-full"
            variant="primary"
            danger={danger}
            onClick={onConfirm}
            loading={isLoading}
            data-testid="modal-confirm"
          >
            {confirmText}
          </Button>
        </div>
      }
      data-testid="confirmation-modal"
    >
      <div className="flex gap-4 pt-2 pb-2">
        <ExclamationCircleFilled className="text-2xl text-[#faad14] mt-1" />
        <div className="flex flex-col gap-2">
          <div className="font-figtree font-medium text-base text-[#000000D9]" data-testid="modal-title">
            {title}
          </div>
          <div className="font-figtree text-sm text-[#757575]" data-testid="modal-description">
            {description}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
